<template>
  <div class="index-wrap">
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
// import mapChart from "../components/G2charts/map-chart.vue";
// import getpk from '../encrypt/getPassKey' // 获取密码加密函数
// console.log(getpk)
// import api from "../api/index";
export default {
  components: {
  },
  name: "index",
  data() {
    return {};
  },
  methods: {
    ...mapActions([])
  },
  watch: {
    allNumber(newVal) {
      console.log(newVal);
    }
  },
  computed: {
    ...mapGetters([])
  },
  created() {},
  mounted() {}
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" rel="stylesheet/scss">
@import "../assets/scss/variables";
@import "../assets/scss/mixins";
#chartId {
  width: 809px;
  height: 649px;
  overflow: hidden;
}
</style>